import { from } from 'rxjs'
import { pluck } from 'rxjs/operators'
import { checkStatus, mapResponse } from 'utils/rxUtils'
import { KnowledgebaseAPI } from 'api'
import queryString from 'query-string'
import { parseFetchArticleResponse } from './helpers'

export const api = {
  createArticle(properties) {
    return from(KnowledgebaseAPI
      .post('/', properties))
      .pipe(
        checkStatus()
      )
  },

  checkTitle({ title, orgId }) {
    return from(KnowledgebaseAPI
      .head(`/checkTitle/?${queryString.stringify({title, orgId})}`))
      .pipe(
        checkStatus()
      )
  },
  
  checkSlug({ slug, orgId }) {
    return from(KnowledgebaseAPI
      .head(`/checkSlug/?${queryString.stringify({slug, orgId})}`))
      .pipe(
        checkStatus()
      )
  },
  
  deleteArticle(properties) {
    properties.knowledgebaseId = ''
    if (!properties.document) properties.document = '<div></div>'
    return from(KnowledgebaseAPI
      .delete('/', properties))
      .pipe(
        checkStatus()
      )
  },
  
  createCategory(properties) {
    properties.knowledgebaseId = ''
    return from(KnowledgebaseAPI
      .post('/admin/category', properties))
      .pipe(
        checkStatus(),
        pluck('data')
      )
  },
  
  editCategory(properties) {
    properties.knowledgebaseId = ''
    return from(KnowledgebaseAPI
    .put('/admin/category', properties))
    .pipe(
      checkStatus()
    )
  },
  
  deleteCategory(properties) {
    properties.knowledgebaseId = ''
    return from(KnowledgebaseAPI
    .delete('/admin/category', properties))
    .pipe(
      checkStatus()
    )
  },
  
  reorderCategories(properties) {
    properties.knowledgebaseId = ''
    return from(KnowledgebaseAPI
      .patch('/admin/category/reorder', properties))
      .pipe(
        pluck('data')
      )
  },
  
  reorderSections(properties) {
    return from(KnowledgebaseAPI
      .patch('/admin/section/reorder', properties))
      .pipe(
        pluck('data')
      )
  },
  
  reorderArticles(properties) {
   return from(KnowledgebaseAPI
    .patch('/admin/document/reorder', properties))
    .pipe(
      pluck('data')
    )
  },
  
  editArticle(properties) {
    return from(KnowledgebaseAPI
      .put('/', properties))
      .pipe(
        checkStatus(),
        pluck('data')
      )
  },
  
  fetchArticle({ orgId, slug }) {
    return from(KnowledgebaseAPI
      .get(`/edit/?${queryString.stringify({orgId, slug})}`))
      .pipe(
        checkStatus(),
        mapResponse(response => {
          return parseFetchArticleResponse(response)
        })
      )
  },
  
  fetchCategories() {
    return from(KnowledgebaseAPI
      .get('/admin'))
      .pipe(
        checkStatus(),
        pluck('data')
      )
  },
  
  createSection(section) {
    section.knowledgebaseId = ''
    return from(KnowledgebaseAPI
      .post('/admin/section', section))
      .pipe(
        checkStatus(),
        pluck('data')
      )
  },
  
  saveSectionEdits(section) {
    section.knowledgebaseId = ''
    return from(KnowledgebaseAPI
      .put('/admin/section', section))
      .pipe(
        checkStatus(),
        pluck('data')
      )
  },
  
  deleteSection(section) {
    section.knowledgebaseId = ''
    return from(KnowledgebaseAPI
      .delete('/admin/section', section))
      .pipe(
        checkStatus(),
        pluck('data')
      )
  }
}